var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 70,
    viewBox: "0 0 52 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_11009)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1146 0.185814C52.1146 0.0867131 52.0278 0 51.9287 0H51.904C8.63413 4.11268 3.12165 33.9544 17.2683 43.4804C14.8279 54.2452 17.0949 53.9975 17.0949 53.9975C17.5284 50.7891 18.1726 47.6055 18.9902 44.4714C24.515 23.4869 38.1661 5.16562 51.9411 0.384015C52.0402 0.371628 52.1146 0.284915 52.1146 0.185814Z",
    fill: "#D93748"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8229 7.04812C49.8229 6.93663 49.7362 6.8623 49.6371 6.8623C49.5504 6.8623 49.4884 6.91185 49.4512 6.98618C45.8712 13.9976 44.8431 24.0315 42.1178 31.7118C38.9961 40.4946 33.4589 46.4159 24.9114 45.8584V67.2146C24.9114 67.2146 2.06873 56.8834 2.06873 40.2592V9.14162L20.7368 7.43213C20.8483 7.43213 20.935 7.34542 20.935 7.23393C20.935 7.13483 20.8607 7.04812 20.7492 7.04812H0V40.2716C0 58.9645 24.9114 69.3453 24.9114 69.3453C24.9114 69.3453 49.8353 58.7911 49.8353 40.2716V7.04812H49.8229Z",
    fill: "#D93748"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_11009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 69.3333,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f7f635133c1b23777a4c1bc5b09998c7.svg";
export { ForwardRef as ReactComponent };